
import { Tbl_cartellinoEdit } from './tbl_cartellinoEdit';
import { Tbl_cartellinoList } from './tbl_cartellinoList';
import { Tbl_cartellinoShow } from './tbl_cartellinoShow';
import { Tbl_cartellinoCreate } from './tbl_cartellinoCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_cartellinoList,
    edit: Tbl_cartellinoEdit,
    show: Tbl_cartellinoShow,
    create: Tbl_cartellinoCreate,
    icon: MapIcon
};
            